import { SPORTO_LOGO_URL } from '@/components/auth/constants';
import { useSystemBarsStyle, systemBarsIconsForBackground } from '@/hooks/useSystemBarsStyle';
import { Button } from '../shadcn/button';

interface AuthLogoProps {
  className?: string;
}

export function AuthLogo({ className }: AuthLogoProps) {
  return (
    <img
      src={SPORTO_LOGO_URL}
      alt="sporto"
      className={className}
    />
  );
}

interface AuthMobileLayoutProps {
  children: React.ReactNode;
  backLink?: React.ReactNode;
}

export function AuthMobileLayout({ children, backLink }: AuthMobileLayoutProps) {
  useSystemBarsStyle(systemBarsIconsForBackground('dark'));

  return (
    <div className="flex min-h-dvh flex-col bg-gc-50 pb-safe">
      <div className="flex min-h-auth-hero-safe items-center justify-center bg-primary-500 px-4">
        <AuthLogo className="h-10 w-auto brightness-0 invert" />
      </div>
      <div className="relative z-10 -mt-6 flex-1 rounded-t-3xl bg-white px-5 pt-6 pb-8">
        {children}
        {backLink && (
          <Button
            variant="secondary"
            className="mt-6 w-full bg-primary-50 text-primary-600 hover:bg-primary-100 hover:text-primary-700"
            asChild
          >
            {backLink}
          </Button>
        )}
      </div>
    </div>
  );
}

interface AuthDesktopLayoutProps {
  children: React.ReactNode;
}

export function AuthDesktopLayout({ children }: AuthDesktopLayoutProps) {
  return (
    <div className="flex min-h-dvh items-center justify-center bg-gc-50 p-4">
      <div className="w-full max-w-md">
        <div className="mb-6 flex justify-center">
          <AuthLogo className="h-10 w-auto" />
        </div>
        <div className="rounded-2xl bg-white p-6 shadow-lg">
          {children}
        </div>
      </div>
    </div>
  );
}
